// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"e795e4b3","444":"5283c715","538":"a47c08fb","994":"3b2c6214"}[chunkId] + ".chunk.css";
};